<template>
 <Navbar/>
  <HeroSection/>
  <Form/>
  <Statistics/>
  <Boost/>
  <Footer/>
</template>

<script>

import Form from './components/Form'
import Navbar from './components/Navbar'
import HeroSection from './components/HeroSection'
import Statistics from './components/Statistics'
import Boost from './components/Boost'
import Footer from './components/Footer'

export default {
  name: 'App',
  components: {
    Form,
    Navbar,
    HeroSection, 
    Statistics,
    Boost,
    Footer
}
}
</script>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

  *{
    font-family: 'Poppins', sans-serif;
  }
</style>
